<template>
  <div>
    <div class="max-w-2xl w-full mx-auto flex flex-col items-center">
      <div class="w-full mb-4">
        <Transition name="fade" mode="out-in">
          <div v-if="!showComboView && !show2ndList" key="buttons1">
            <p class="font-bold mb-5">What’s your business activity?</p>
            <!-- show selected industry if doesn't match sic code or first list of industries -->
            <DrButton
              v-if="industry.value"
              :disabled="loading"
              class="mb-4 btn-block btn-blue"
              @click.prevent="selectIndustry(industry)"
            >
              {{ industry.label }}
            </DrButton>
            <div>
              <DrLoader v-if="showLoader" style="margin-top: 50px;" />
              <div v-else>
                <!-- show industries from sic codes -->
                <DrButton
                  v-for="activity in sicCodeIndustries.filter(item => item.id !== industry.value)"
                  :key="activity.id"
                  :value="activity.id"
                  :class="{
                    isActive: activity.id === industry.value,
                    'opacity-50': industry.value,
                  }"
                  :loading="loading && selectedId === activity.id"
                  :disabled="loading"
                  class="mb-4 btn-block btn-blue"
                  @click.prevent="selectIndustry(activity)"
                >
                  {{ activity.label }}
                </DrButton>
                <!-- show industries from hard coded list -->
                <div>
                  <DrButton
                    v-for="(activity, index) in displayIndustries(industries1)"
                    :key="activity.value"
                    :data-cy="`business-activity-btn-${index}`"
                    :value="activity.value"
                    :class="{
                      isActive: activity.value === industry.id,
                      'opacity-50': industry.id || (sicCodeIndustries.length && !industry.id),
                    }"
                    :loading="loading && selectedId === activity.value"
                    :disabled="loading"
                    class="mb-4 btn-block btn-blue"
                    @click.prevent="selectIndustry(activity)"
                  >
                    {{ activity.label }}
                  </DrButton>
                  <DrButton
                    class="btn-outline btn-block btn-blue"
                    data-cy="btn-none-activites"
                    @click.prevent="show2ndList = true"
                  >
                    None of these activities
                  </DrButton>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="show2ndList" key="buttons2">
            <p class="font-bold mb-5">What’s your business activity?</p>
            <DrButton
              v-for="activity in displayIndustries(industries2)"
              :key="activity.value"
              :value="activity.value"
              :class="{
                isActive: activity.value === industry.id,
                'opacity-50': industry.id || (sicCodeIndustries.length && !industry.id),
              }"
              :loading="loading && selectedId === activity.value"
              :disabled="loading"
              class="mb-4 btn-block btn-blue"
              @click.prevent="selectIndustry(activity)"
            >
              {{ activity.label }}
            </DrButton>
            <DrButton
              class="btn-outline btn-block btn-blue"
              data-cy="btn-none-activites2"
              @click.prevent="
                show2ndList = false
                showComboView = true
              "
            >
              None of these activities
            </DrButton>
          </div>

          <div v-else key="combo" class="flex flex-col relative">
            <p class="font-bold mb-5">
              Start typing to find your business activity
            </p>
            <div v-ClickOutside="hideIfClick">
              <DrInput
                ref="search"
                v-model="searchInput"
                class="mb-1"
                placeholder="Business activity"
                data-cy="input-find-activity"
                @focus="inputFocus"
                @keyup.esc="hideAll"
                @input="searchIndustries"
              />
              <IndustrySelect
                v-if="focus"
                :loading="loading"
                :api-industries="apiIndustries"
                :input-length="searchInput.length"
                @change="selectIndustry"
              />
            </div>
          </div>
        </Transition>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from '../../directives/ClickOutside'
import IndustrySelect from './IndustrySelect'
import axiosCompaniesHouseApi from '@/services/axiosCompaniesHouseApi'
import axiosRatingEngine from '@/services/axiosRatingEngine'

export default {
  components: {
    IndustrySelect,
  },
  directives: {
    ClickOutside,
  },
  data () {
    return {
      showLoader: false,
      showComboView: false,
      show2ndList: false,
      searchInput: '',
      focus: false,
      loading: false,
      selectedId: '',
      debounceTimeout: null,
      apiIndustries: [],
      sicCodeIndustries: [],
    }
  },
  computed: {
    industry: {
      get () {
        return this.$store.getters.getIndustry
      },
      set (value) {
        this.$store.commit('updateIndustry', value)
      },
    },
    industries1 () {
      return [
        {
          label: 'Software and IT Services',
          id: 'a16f1768-e9a6-4784-9156-3618ebed9849',
        },
        {
          label: 'Marketing, Advertising, Communications',
          id: '7475b9a6-3fe7-4ded-a726-729a7f9ffa80',
        },
        {
          label: 'Management Consultancy',
          id: 'bc3e7edc-0e80-4305-921a-061741748d76',
        },
        {
          label: 'E-Commerce',
          id: 'd9e543a4-68fb-445a-a8e1-83fb5674db77',
        },
        {
          label: 'Legal Services',
          id: 'c0264a2e-2255-4356-ba3c-58b076d019c8',
        },
        {
          label: 'Financial Services',
          id: '8435fc26-94c1-4285-a40d-7356ba4e7c0d',
        },
      ]
    },
    industries2 () {
      return [
        {
          label: 'Photographers and Videographers',
          id: '0652a986-0b97-4d84-9a41-5587e43bdb28',
        },
        {
          label: 'Recruitment and Supply of Personnel',
          id: '6b25abb3-d813-4ee6-a12c-7ec4bba3bdc0',
        },
        {
          label: 'Accounting, Audit, Tax Services',
          id: 'e12b1deb-97ba-48fb-b98f-d07a84d142d0',
        },
        {
          label: 'Property Sales, Letting, Management',
          id: '99c85cd2-289e-4615-ad63-9bcd8d4a149b',
        },
        {
          label: 'Event and Conference Organising',
          id: 'bb1503f8-9e6a-4784-b45c-00d6c93d3c3d',
        },
        {
          label: 'Sports and Personal Training',
          id: '202dde37-543f-4b5c-a0a6-7fea7e0d0bfc',
        },
      ]
    },
  },
  async created () {
    if (this.$store.getters.getBusinessNumber) {
      this.showLoader = true
      await axiosCompaniesHouseApi
        .get(`company/${this.$store.getters.getBusinessNumber}`)
        .then((response) => {
          this.$store.commit('updateSicCodes', response.data.sic_codes)

          axiosRatingEngine
            .post('sics-to-activities', { codes: response.data.sic_codes })
            .then((ratingEngineResponse) => {
              if (ratingEngineResponse.data.activities.length) this.sicCodeIndustries = ratingEngineResponse.data.activities
              this.showLoader = false
            })
            .catch(() => {
              this.showLoader = false
            })
        })
        .catch(() => {
          this.showLoader = false
        })
    }
  },
  methods: {
    displayIndustries (list) {
      const displayList = [...list]
      if (this.sicCodeIndustries.length) {
        this.sicCodeIndustries.forEach((activity) => {
          const index = displayList.map(e => e.value).indexOf(activity.id)
          if (index > -1) displayList.splice(index, 1)
        })
      }
      if (this.industry.value) {
        const index = displayList.map(e => e.value).indexOf(this.industry.value)
        if (index > -1) displayList.splice(index, 1)
      }
      return displayList
    },
    inputFocus () {
      this.focus = true
    },
    hideIfClick () {
      if (!window.getSelection().toString()) this.hideAll()
    },
    hideAll () {
      this.$refs.search.$refs.input.blur()
      this.focus = false
    },
    async searchIndustries () {
      if (this.searchInput.length) {
        clearTimeout(this.debounceTimeout)
        this.loading = true
        this.debounceTimeout = await setTimeout(() => {
          // send tracking params to Google Tag manager
          this.pushDataLayer(this.searchInput)

          // get industry from rating engine by search query
          axiosRatingEngine
            .get(`api/industry/search?q=${this.searchInput}&is_active=1`)
            .then((response) => {
              this.loading = false
              this.apiIndustries = response.data.results
            })
        }, 500)
      }
    },
    selectIndustry (activity) {
      const activityId = activity.id
      const activityText = activity.label

      this.selectedId = activityId
      this.industry = {
        id: activityId,
        value: activityId,
        text: activityText,
        label: activityText,
      }

      // send tracking params to Google Tag manager
      this.pushDataLayer(activityText)
      this.pushDataLayerIndustry(activity)
      this.$router.push('/turnover')
    },
    pushDataLayer (activity) {
      // @TODO - this should be legacy, but need to review closer to see not used in the analytics reviews/reports
      // send tracking params to Google Tag manager
      const payload = {
        event: 'activitySelect',
        activity,
      }
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push(payload)
    },
    pushDataLayerIndustry (industry) {
      const industryId = industry.id
      const industryText = industry.label

      // send tracking params to Google Tag manager
      const payload = {
        event: 'industrySelect',
        industryId,
        industryText,
      }
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push(payload)
    },
  },
}
</script>
